module.exports = __webpack_public_path__ + "static/media/profile.6d7e76c7.PNG";